import React from 'react';
import { motion } from 'framer-motion';
import { C } from '../constants';
import { useTheme } from '../contexts/ThemeContext';

// Company logos - using placeholder SVGs that look professional
const companyLogos = [
  { name: 'TechCrunch', svg: <svg width="120" height="32" viewBox="0 0 120 32" fill="currentColor"><text x="0" y="24" fontSize="20" fontWeight="700" fontFamily="Arial">TechCrunch</text></svg> },
  { name: 'Y Combinator', svg: <svg width="100" height="32" viewBox="0 0 100 32" fill="currentColor"><rect x="0" y="4" width="24" height="24" rx="4"/><text x="30" y="22" fontSize="14" fontWeight="600" fontFamily="Arial">Y Combinator</text></svg> },
  { name: 'Sequoia', svg: <svg width="90" height="32" viewBox="0 0 90 32" fill="currentColor"><text x="0" y="24" fontSize="20" fontWeight="700" fontFamily="Arial">SEQUOIA</text></svg> },
  { name: 'a16z', svg: <svg width="60" height="32" viewBox="0 0 60 32" fill="currentColor"><text x="0" y="24" fontSize="22" fontWeight="700" fontFamily="Arial">a16z</text></svg> },
  { name: 'Accel', svg: <svg width="70" height="32" viewBox="0 0 70 32" fill="currentColor"><text x="0" y="24" fontSize="20" fontWeight="700" fontFamily="Arial">ACCEL</text></svg> },
  { name: 'Index', svg: <svg width="70" height="32" viewBox="0 0 70 32" fill="currentColor"><text x="0" y="24" fontSize="20" fontWeight="700" fontFamily="Arial">INDEX</text></svg> },
  { name: 'Peak XV', svg: <svg width="80" height="32" viewBox="0 0 80 32" fill="currentColor"><text x="0" y="24" fontSize="18" fontWeight="700" fontFamily="Arial">PEAK XV</text></svg> },
  { name: 'Matrix', svg: <svg width="80" height="32" viewBox="0 0 80 32" fill="currentColor"><text x="0" y="24" fontSize="20" fontWeight="700" fontFamily="Arial">MATRIX</text></svg> },
  { name: 'Tiger Global', svg: <svg width="100" height="32" viewBox="0 0 100 32" fill="currentColor"><text x="0" y="24" fontSize="16" fontWeight="700" fontFamily="Arial">TIGER GLOBAL</text></svg> },
  { name: 'Lightspeed', svg: <svg width="100" height="32" viewBox="0 0 100 32" fill="currentColor"><text x="0" y="24" fontSize="16" fontWeight="700" fontFamily="Arial">LIGHTSPEED</text></svg> },
];

export const LogoScroll = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  
  // Double the logos for seamless infinite scroll
  const doubledLogos = [...companyLogos, ...companyLogos];
  
  return (
    <div
      style={{
        padding: '48px 0',
        background: isDark ? 'rgba(0,0,0,0.3)' : 'rgba(255,255,255,0.5)',
        backdropFilter: 'blur(10px)',
        borderTop: `1px solid ${isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'}`,
        borderBottom: `1px solid ${isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'}`,
        overflow: 'hidden',
        position: 'relative'
      }}
      data-testid="logo-scroll-section"
    >
      {/* Eyebrow text */}
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        style={{
          textAlign: 'center',
          marginBottom: '32px'
        }}
      >
        <span
          style={{
            fontSize: '13px',
            fontWeight: 600,
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            color: isDark ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)'
          }}
        >
          Loved by 1000+ Founders & B2B Teams
        </span>
      </motion.div>
      
      {/* Gradient fade edges */}
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: '100px',
          background: isDark 
            ? 'linear-gradient(to right, rgba(9,10,11,1), transparent)'
            : 'linear-gradient(to right, rgba(255,255,255,1), transparent)',
          zIndex: 2,
          pointerEvents: 'none'
        }}
      />
      <div
        style={{
          position: 'absolute',
          right: 0,
          top: 0,
          bottom: 0,
          width: '100px',
          background: isDark 
            ? 'linear-gradient(to left, rgba(9,10,11,1), transparent)'
            : 'linear-gradient(to left, rgba(255,255,255,1), transparent)',
          zIndex: 2,
          pointerEvents: 'none'
        }}
      />
      
      {/* Scrolling logos container */}
      {/* <div
        style={{
          display: 'flex',
          width: 'max-content',
          animation: 'scrollLogos 30s linear infinite'
        }}
      >
        {doubledLogos.map((logo, index) => (
          <div
            key={`${logo.name}-${index}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0 40px',
              opacity: isDark ? 0.4 : 0.5,
              color: isDark ? '#fff' : '#000',
              transition: 'opacity 0.3s ease',
              flexShrink: 0
            }}
          >
            {logo.svg}
          </div>
        ))}
      </div> */}
      
      {/* CSS animation keyframes */}
      {/* <style>{`
        @keyframes scrollLogos {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style> */}
    </div>
  );
};

export default LogoScroll;
